import { render, staticRenderFns } from "./QuickSideLayout.vue?vue&type=template&id=4d7a356b&scoped=true&"
import script from "./QuickSideLayout.vue?vue&type=script&lang=js&"
export * from "./QuickSideLayout.vue?vue&type=script&lang=js&"
import style0 from "./QuickSideLayout.vue?vue&type=style&index=0&id=4d7a356b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a356b",
  null
  
)

export default component.exports